// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__tFIXn","unreadBadge":"styles_unreadBadge__18kKb","modalContent":"styles_modalContent__pb2uM","modal":"styles_modal__3NUGr"};